export default __webpack_public_path__ + "static/media/deniedAccess.2ae49e19.png";